class SampleService {
  public async getProducts(): Promise<any> {
    return fetch("demo/data/sample-products.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
  public async getUser(): Promise<any> {
    return fetch("demo/data/sample-user.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
  public async getComparisons(): Promise<any> {
    return fetch("demo/data/sample-comparisons.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
  getReports() {
    return fetch("demo/data/sample-reports.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
  getGDPR() {
    return fetch("demo/data/sample-gdpr.json")
      .then((res) => res.json())
      .then((d) => d.data);
  }
}
export default new SampleService();
